(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/product-start-page.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/product-start-page.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.app.productStartPage.ProductStartPage = Backbone.Marionette.View.extend({
    className: function() {
      var classes = ['product-start-page'];
      if (this.showSyndicateMode()) {
        classes.push(this.getSyndicateClass());
      }
      if (
        this.options.generalSettings &&
        this.options.generalSettings.customCssClass
      ) {
        classes.push(this.options.generalSettings.customCssClass);
      }
      return classes.join(' ');
    },
    resizeTimerIndex: null,
    regions: {
      mainRegion: '.js-product-start-page-main-area',
      rounds: '.js-product-start-page-rounds-area',
      specialOffer: '.js-product-start-page-special-offer-area',
      tabs: '.js-product-start-page-tabs-area',
      footer: '.js-product-start-page-footer-area'
    },
    ui: {
      top: '.js-product-start-page-top',
      bottom: '.js-product-start-page-bottom'
    },
    events: {
      click: 'fixedOnClick'
    },
    template: function(data) {
      return svs.app.product_start_page.templates.product_start_page(data);
    },
    templateContext: function() {
      return {
        syndicateMode: this.showSyndicateMode(),
        syndicateName: this.getSyndicateName()
      };
    },
    initialize: function() {
      this.onResizeBind = _.bind(this.onResizeView, this);
      $(window).on('resize', this.onResizeBind);

      this.onScrollBind = _.bind(this.onScrollView, this);
      $(window).on('scroll', this.onScrollBind);

      this.log = new svs.core.log.Logger('svs.app.productStartPage.ProductStartPage');
    },
    onDestroy: function() {
      $('body').removeClass(this.getBackgroundClass());
      $(window).off('resize', this.onResizeBind);
      $(window).off('scroll', this.onScrollBind);
    },
    onAttach: function() {
      this.disableScrollEffect = Boolean(this.options.promoRegion.customView);

      if (this.options.promoRegion.defaultPromo) {
        this.showChildView(
          'mainRegion',
          new svs.app.productStartPage.promos.views.DefaultPromos({
            collection: this.options.promoRegion.defaultPromo.items,
            model: new Backbone.Model(this.options.generalSettings)
          })
        );
      } else if (this.options.promoRegion.matchPromo) {
        this.options.promoRegion.matchPromo.settings.set(
          'generalSettings',
          this.options.generalSettings,
          { silent: true }
        );
        this.showChildView(
          'mainRegion',
          new svs.app.productStartPage.promos.views.MatchPromos({
            collection: this.options.promoRegion.matchPromo.items,
            model: this.options.promoRegion.matchPromo.settings
          })
        );
      } else if (this.options.promoRegion.customView) {
        this.showChildView('mainRegion', this.options.promoRegion.customView);
      }

      if (this.options.roundsRegion) {
        this.showChildView(
          'rounds',
          new svs.app.productStartPage.rounds.views.Rounds({
            tabs: this.options.roundsRegion.tabs,
            collection: this.options.roundsRegion.items
          })
        );
      }

      if (
        this.options.specialOffer &&
        this.options.specialOffer.lordagsgodis &&
        !this.showSyndicateMode()
      ) {
        this.showChildView(
          'specialOffer',
          new svs.app.productStartPage.specialOffer.views.Lordagsgodis()
        );
      }

      if (this.options.tabRegion) {
        this.options.tabRegion.set(
          'generalSettings',
          this.options.generalSettings,
          { silent: true }
        );
        this.tabsView = new svs.app.productStartPage.tabs.views.Tabs({
          model: this.options.tabRegion
        });
        this.showChildView('tabs', this.tabsView);
      }

      if (this.options.footerRegion && this.options.footerRegion.buttons) {
        var footerCollection = new Backbone.Collection(this.options.footerRegion.buttons.filter(function(footerItem) {
          return (
            footerItem.get('active') === true &&
              (footerItem.get('formfactor') === 'all' ||
                footerItem.get('formfactor') ===
                svs.core.data.capabilities.formFactor)
          );
        }));
        this.showChildView(
          'footer',
          new svs.app.productStartPage.footer.views.FooterItems({
            collection: footerCollection,
            model: new Backbone.Model(this.options.generalSettings)
          })
        );
      }
      if (
        this.options.generalSettings &&
        this.options.generalSettings.branding
      ) {
        this.$el
          .find('.js-product-start-page-top')
          .addClass('product-start-page-top-' + this.options.generalSettings.branding);
      }

      this.setBackground();

      if (this.tabsView) {
        this.tabsView.lateInit();
      }
      this.onResizeView();

      if (this.showSyndicateMode()) {
        this.$el.addClass('product-start-page-syndicate-show');
      }

      var self = this;

      setTimeout(function() {
        self.onScrollView();
      }, 100);
    },
    fixedOnClick: function(e) {
      if (this.scrollEffectActive) {
        var mouseDownY = e.clientY - $('#top-content').height();
        if (
          mouseDownY > 0 &&
          mouseDownY < this.pxFixedHeight - this.pxFromTop
        ) {
          this.scrollToTop(e);
        }
      }
    },
    scrollToTop: function() {
      var scrollSpeed = ((1000 - 10) * (1 - this.negativePercent)).toFixed(0);

      $('html, body').animate(
        {
          scrollTop: 0
        },
        parseInt(scrollSpeed, 10)
      );
    },
    onResizeView: function() {
      var self = this;
      if (this.negativePercent < 0) {
        this.negativePercent = 0;
      }
      if (this.resizeTimerIndex) {
        clearTimeout(this.resizeTimerIndex);
      }

      this.resizeTimerIndex = setTimeout(function() {
        if (self._isDestroyed) {
          return;
        }

        if (
          !svs.core.detect.formfactor.desktop() ||
          self.disableScrollEffect ||
          self.ui.top.height() + 30 >
          $(window).innerHeight() - $('#top-content').height()
        ) {
          self.scrollEffect = false;
          self.ui.top
            .removeClass('product-start-page-fixed')
            .addClass('product-start-page-relative');

          self.ui.bottom.css('paddingTop', 0);
        } else {
          self.scrollEffect = true;
          self.ui.bottom.css('paddingTop', self.ui.top.height());

          self.ui.top
            .removeClass('product-start-page-relative')
            .addClass('product-start-page-fixed');
        }

        self.pxFixedHeight = self.ui.top.height();
      }, 10);
    },
    onScrollView: function() {
      var self = this;
      if (this.scrollEffect && !this.scrollEffectDisable) {
        this.pxFromTop = $(window).scrollTop();
        this.negativePercent = (
          1 -
          this.pxFromTop / this.pxFixedHeight
        ).toFixed(2);
        if (this.negativePercent < 0) {
          this.negativePercent = 0;
        }
        if (this.negativePercent <= 1 && this.negativePercent >= 0) {
          this.scrollEffectActive = true;

          this.ui.top.removeClass('product-start-page-fixed-scroll-top');

          var y = this.pxFromTop / 30 * -1;

          this.ui.top.css({
            '-webkit-transform': 'matrix(1, 0, 0, 1, 0, ' + y + ')',
            '-moz-transform': 'matrix(1, 0, 0, 1, 0, ' + y + ')',
            '-ms-transform': 'matrix(1, 0, 0, 1, 0, ' + y + ')',
            '-o-transform': 'matrix(1, 0, 0, 1, 0, ' + y + ')',
            transform: 'matrix(1, 0, 0, 1, 0, ' + y + ')',
            opacity: this.negativePercent
          });

          if (this.negativePercent === '1.00') {
            this.scrollEffectReset();
          }
        }

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function() {
          if (self.pxFromTop > 0 && self.pxFromTop < 30) {
            self.scrollToTop();
          }
        }, 500);
      }
    },
    scrollEffectReset: function() {
      this.ui.top.addClass('product-start-page-fixed-scroll-top');
      this.ui.top.css({
        opacity: 1
      });
      this.scrollEffectActive = false;
    },
    setBackground: function() {
      if (svs.core.detect.feature('ft-product-start-fullwidth')) {
        var topBackground = $('.product-start-page');
        var promoBackground = $('.promo-box');
        promoBackground.addClass(this.getBackgroundClass());
        topBackground.addClass(this.getBackgroundClass());
      } else {
        var body = $('body');
        body.removeClass('bg-grey-300');
        body.addClass(this.getBackgroundClass());
      }
    },
    getBackgroundClass: function() {
      var backgroundClass; var branding;

      if (
        this.options.generalSettings &&
        this.options.generalSettings.branding
      ) {
        branding = this.options.generalSettings.branding;
        if (
          branding === 'triss' ||
          branding === 'bingo' ||
          branding === 'topptipset'
        ) {
          backgroundClass = 'bg-' + branding + '-200';
        } else if (branding === 'poker') {
          backgroundClass = 'bg-grey-600';
        } else if (branding === 'eurojackpot') {
          backgroundClass = 'bg-eurojackpot-500';
        } else if (
          branding === 'default' ||
          branding === 'svenska-spel' ||
          branding === 'bingo-light' ||
          branding === 'vikinglotto'
        ) {
          backgroundClass = 'bg-grey-330';
        } else {
          backgroundClass = 'bg-' + branding + '-500';
        }
      } else {
        backgroundClass = 'bg-grey-800';
      }

      return backgroundClass;
    },
    showSyndicateMode: function() {
      return (
        this.options.generalSettings &&
        this.options.generalSettings.isSyndicateMode &&
        svs.syndicate &&
        svs.syndicate.AccountSelector &&
        svs.syndicate.AccountSelector.getAccountModel().isSyndicateActive()
      );
    },
    getSyndicateName: function() {
      if (this.isSyndicateModeDeprecated()) {
        return '';
      }
      return (
        this.showSyndicateMode() &&
        svs.syndicate.AccountSelector.getAccountModel().get('syndicateName')
      );
    },
    getSyndicateClass: function() {
      if (this.isSyndicateModeDeprecated()) {
        return 'product-start-page-syndicate-deprecated';
      }
      return 'product-start-page-syndicate';
    },
    isSyndicateModeDeprecated: function() {
      return Boolean(svs.core.detect.tenant('mb'));
    }
  });
})(Backbone, _, svs);

 })(window);